// src/services/firebase.js
// Firebase 초기화 - 웹과 동일한 프로젝트 연결
// Expo SDK에서는 firebase/compat 대신 modular API(v9+) 사용

import { Platform } from 'react-native';
import { initializeApp, getApps } from 'firebase/app';
import {
  getAuth,
  initializeAuth,
  getReactNativePersistence,
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import AsyncStorage from '@react-native-async-storage/async-storage';

// Expo의 환경변수는 EXPO_PUBLIC_ 접두사 필요
const firebaseConfig = {
  apiKey: process.env.EXPO_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.EXPO_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.EXPO_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.EXPO_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.EXPO_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.EXPO_PUBLIC_FIREBASE_APP_ID,
  measurementId: process.env.EXPO_PUBLIC_FIREBASE_MEASUREMENT_ID,
};

// 중복 초기화 방지 (Hot Reload 대응)
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

// 78차 39차: 웹 버전 접속 시 화면 자체가 안 뜨던 버그 — getReactNativePersistence는
// React Native 전용 API라, 웹 번들에서 firebase/auth가 브라우저용 빌드로 해석되면
// 이 함수 자체가 없어(또는 AsyncStorage 기반 persistence가 브라우저 컨텍스트와
// 안 맞아) initializeAuth 호출 시점에 죽어서 앱 전체가 하얀 화면으로 멈췄던 것으로
// 추정됨 — 웹에서는 Auth SDK 기본 동작(getAuth, 자동 브라우저 저장소 사용)으로 분기.
let auth;
if (Platform.OS === 'web') {
  auth = getAuth(app);
} else {
  // Auth: React Native는 AsyncStorage로 세션 유지
  // initializeAuth는 앱당 한 번만 호출 가능
  try {
    auth = initializeAuth(app, {
      persistence: getReactNativePersistence(AsyncStorage),
    });
  } catch (e) {
    // 이미 초기화된 경우 getAuth() 사용
    auth = getAuth(app);
  }
}

const db        = getFirestore(app);
const storage   = getStorage(app);
// 79차: [주석 정정] "httpsCallable이 리전을 자동 감지"한다는 이전 설명은 부정확함
// (그런 자동감지 기능은 SDK에 없음, 실제로 이 오해 때문에 CF 호출 시 리전을 잘못
// 지정해 functions/not-found를 겪은 적이 있음 — 공용 인프라 재정독 fork로 발견).
// 실제로는: 이 프로젝트의 onCall(callable) 함수는 전부 리전을 명시하지 않아 기본값인
// us-central1에 배포되고, 이 getFunctions(app)도 리전 인자 없이 기본값(us-central1)을
// 쓰므로 우연히 일치하는 것 — Firestore 트리거(onDocumentCreated 등, asia-northeast3
// 배포)는 애초에 httpsCallable로 부르지 않으니 여기와 무관.
const functions = getFunctions(app);
// 80차 계속: [성능 수정] getAvailableSlotsCF/getShowSlotCountsCF만 asia-northeast3로
// 이전(functions/index.js 참고, 날짜 선택마다 호출되는 핫패스라 미국 왕복 지연 제거 목적) —
// 이 인스턴스로 호출해야 실제로 그 리전의 엔드포인트를 사용함(리전 미지정 시 기본값
// us-central1로 가서 함수 자체를 못 찾음). 나머지 CF는 전부 기존 functions(위) 그대로.
const functionsAsia = getFunctions(app, 'asia-northeast3');

export { app, auth, db, storage, functions, functionsAsia };